import { BrowserModule } from '@angular/platform-browser';
import { NgModule, ErrorHandler, LOCALE_ID } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { SplashScreen } from '@ionic-native/splash-screen';
import { StatusBar } from '@ionic-native/status-bar';
import { Keyboard } from '@ionic-native/keyboard';
import { IonicStorageModule } from '@ionic/storage';
import { HttpModule } from '@angular/http';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { Geolocation } from '@ionic-native/geolocation';


// Dates
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
registerLocaleData(localeFr);

// Modules
import { MyApp } from './app.component';
import { ComponentsModule } from '../components/components.module';
import { LoginPageModule } from '../pages/login/login.module';
import { LoginModalPageModule } from '../pages/login-modal/login-modal.module';
import { TabsPageModule } from '../pages/tabs/tabs.module';
import { RegisterPageModule } from '../pages/register/register.module';
import { ExplorePageModule } from '../pages/explore/explore.module';
import { UserPageModule } from '../pages/user/user.module';
import { EventsPageModule } from '../pages/events/events.module';
import { EventCreatePageModule } from '../pages/event-create/event-create.module';
import { EventPageModule } from '../pages/event/event.module';
import { AccountPageModule } from '../pages/account/account.module';
import { NotificationsPageModule } from '../pages/notifications/notifications.module';


// Firebase
import { AngularFireModule } from 'angularfire2';
import { AngularFireAuthModule } from 'angularfire2/auth';
import { AngularFirestoreModule } from 'angularfire2/firestore';
import { AngularFirestore } from 'angularfire2/firestore';
import { AngularFireDatabaseModule } from 'angularfire2/database';
import { AngularFireStorageModule } from 'angularfire2/storage';
import { environment } from '../environment/environment';

// Providers
import { Facebook } from '@ionic-native/facebook';
import { GooglePlus } from '@ionic-native/google-plus';
import { TwitterConnect } from '@ionic-native/twitter-connect';
import { Camera } from '@ionic-native/camera';
import { EventsProvider } from '../providers/events/events.provider';
import { AuthProvider } from '../providers/auth/auth.provider';
import { UserProvider } from '../providers/user/user.provider';
import { CategoriesProvider } from '../providers/categories/categories.provider';
import { MockupProvider } from '../providers/mockup/mockup.provider';

import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { AccountUpdatePageModule } from '../pages/account-update/account-update.module';
import { GeocodingProvider } from '../providers/geocoding/geocoding.provider';
import { CategorieResultPageModule } from '../pages/categorie-result/categorie-result.module';
import { ChatListPageModule } from '../pages/chat-list/chat-list.module';
import { ChatPageModule } from '../pages/chat/chat.module';
import { ChatInfoPageModule } from '../pages/chat-info/chat-info.module';
import { ChatProvider } from '../providers/chat/chat.provider';
import { MapPageModule } from '../pages/map/map.module';
import { WelcomePage } from '../pages/welcome/welcome';
import { WelcomePageModule } from '../pages/welcome/welcome.module';
import { PresentationPageModule } from '../pages/presentation/presentation.module';
import { QrcodePage } from '../pages/qrcode/qrcode';
import { QrcodePageModule } from '../pages/qrcode/qrcode.module';
import { AbonnementPageModule } from '../pages/abonnement/abonnement.module';
import { InAppPurchase } from '@ionic-native/in-app-purchase/ngx';


export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

export class AppExceptionHandler
  // implements ErrorHandler {
  extends IonicErrorHandler  {

  handleError(error:any){
    switch(error.message){
      case "Network Error" : { this.handleNetworkError(); break; }
      default : super.handleError(error);
    }
  }

  handleNetworkError(){
    console.log('handling "network down" situation');
  }
}

@NgModule({
  declarations: [
    MyApp
  ],
  imports: [
    BrowserModule,
    ComponentsModule,
    LoginPageModule,
    LoginModalPageModule,
    RegisterPageModule,
    TabsPageModule,
    EventsPageModule,
    EventCreatePageModule,
    EventPageModule,
    ExplorePageModule,
    CategorieResultPageModule,
    NotificationsPageModule,
    ChatListPageModule,
    ChatPageModule,
    ChatInfoPageModule,
    MapPageModule,
    UserPageModule,
    AccountPageModule,
    AccountUpdatePageModule,
    WelcomePageModule,
    PresentationPageModule,
    QrcodePageModule,
    AbonnementPageModule,
    IonicModule.forRoot(MyApp,{
      backButtonText: '',
      backButtonIcon: 'ios-arrow-back',
      iconMode: 'md'}),
    IonicStorageModule.forRoot(),
    HttpClientModule,
    HttpModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient]
      }
    }),
    AngularFireModule.initializeApp(environment.firebase),
    AngularFirestoreModule,
    AngularFireAuthModule,
    AngularFireDatabaseModule,
    AngularFireStorageModule
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp
  ],
  providers: [
    StatusBar,
    SplashScreen,
    Camera,
    Facebook,
    GooglePlus,
    TwitterConnect,
    AngularFirestore,
    Keyboard,
    {provide: LOCALE_ID, useValue: "fr-CA" },
    {provide: ErrorHandler, useClass: AppExceptionHandler },
    EventsProvider,
    AuthProvider,
    UserProvider,
    CategoriesProvider,
    MockupProvider,
    GeocodingProvider,
    ChatProvider,
    InAppPurchase,
    Geolocation
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts